<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="modal-header">
  <h5 class="modal-title" [xdaTranslate]="title"></h5>
  @if (showCancelHeaderButton) {
  <button type="button"
          class="modal-close-btn"
          data-dismiss="modal"
          aria-label="Close"
          (click)="activeModal.dismiss()">
    <span aria-hidden="true" class="xgl-close"></span>
  </button>
  }
</div>
<div class="modal-body" tabindex="-1">
  <p [xdaTranslate]="body"></p>
</div>
<div class="modal-footer">
  <div class="cb">
    <button
      type="button"
      class="xrx-btn btn-secondary"
      data-dismiss="modal"
      (click)="activeModal.dismiss()">
      <span class="btn-label" [xdaTranslate]="'SDE_CANCEL'"></span>
    </button>
  </div>
  <div class="cb">
    <button
      type="button"
      class="xrx-btn btn-primary"
      (click)="activeModal.close()">
      <span class="btn-label" [xdaTranslate]="okButtonText"></span>
    </button>
  </div>
</div>
